import React from 'react';
import PositionOnlyPopperPopover from '../PositionOnlyPopperPopover';
var PopoverPopover = function (_a) {
    var contentClassName = _a.contentClassName, referenceClassName = _a.referenceClassName, children = _a.children, tooltipOffset = _a.tooltipOffset, placement = _a.placement, secondaryPlacement = _a.secondaryPlacement, onClose = _a.onClose, onReferenceClick = _a.onReferenceClick, renderPopover = _a.renderPopover;
    return (React.createElement(PositionOnlyPopperPopover, { className: referenceClassName, placement: placement, secondaryPlacement: secondaryPlacement, isVisible: true, onClickOutside: onClose, modifiers: {
            offset: {
                offset: tooltipOffset || '0, 8',
            },
        }, contentClassName: contentClassName, onReferenceClick: onReferenceClick, popoverContent: function (_a) {
            var updatePositioning = _a.updatePositioning;
            return (renderPopover &&
                renderPopover({
                    scheduleTooltipUpdate: updatePositioning,
                    closeTooltip: onClose,
                }));
        } }, children));
};
PopoverPopover.displayName = 'PopoverPopover';
export default PopoverPopover;
//# sourceMappingURL=PopoverPopover.js.map